export default "__VITE_ASSET__CchgIlGX__"